import { useEffect } from 'react';
import { useCookieConsent } from './CookieConsentContext';

const ADSENSE_SCRIPT_ID = 'mybricklog-adsense-script';

function ensureAdSenseLoaded(clientId) {
  if (!clientId) {
    return;
  }

  if (document.getElementById(ADSENSE_SCRIPT_ID)) {
    return;
  }

  const script = document.createElement('script');
  script.id = ADSENSE_SCRIPT_ID;
  script.async = true;
  script.crossOrigin = 'anonymous';
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${clientId}`;
  document.head.appendChild(script);
}

const AdSenseConsentGate = () => {
  const { consent, loading } = useCookieConsent();
  const clientId = process.env.REACT_APP_ADSENSE_CLIENT_ID;

  useEffect(() => {
    if (loading) {
      return;
    }

    if (!clientId) {
      if (process.env.NODE_ENV !== 'production') {
        console.info(
          'AdSense disabled: set REACT_APP_ADSENSE_CLIENT_ID to enable it.'
        );
      }
      return;
    }

    if (consent === 'all') {
      ensureAdSenseLoaded(clientId);
    }
  }, [consent, loading, clientId]);

  return null;
};

export default AdSenseConsentGate;
